<template>
  <div id="staff">
    <p class="top">
      <span>{{ companyName }}</span>
      <logout />
    </p>
    <div class="left">
      <el-menu
        :default-active="activeIndex"
        class="layout-menu"
        background-color="#ecf5ff"
        active-text-color="#FFF"
        text-color="#333"
        @select="handleSelect"
      >
        <el-menu-item
          v-for="(item, index) in MenuList"
          :key="index"
          :index="index.toString()"
        >
          <p slot="title">{{ item.title }}</p>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="right">
      <div class="main">
        <el-scrollbar style="height:100%">
          <router-view />
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import logout from '@/components/common/logout'
import { mapGetters } from 'vuex'

export default {
  name: 'staff',
  components: {
    logout,
  },
  data () {
    return {
      activeIndex: '0',
      MenuList: [
        { path: '/staff', title: '个人信息' },
        { path: '/staff/salary', title: '薪酬统计' },
        { path: '/staff/salaryInfo', title: '薪酬信息' },
      ],
    }
  },
  created () {
    this.changePath()
  },
  computed: {
    ...mapGetters(['companyName']),
  },
  methods: {
    handleSelect (_index) {
      let _path = this.MenuList[_index]
      if (_path.path == this.$route.path) {
        return
      }
      this.activeIndex = _index
      this.$router.push(_path.path)
    },
    changePath () {
      let _path = this.$route.path
      for (let i in this.MenuList) {
        if (_path == this.MenuList[i].path) {
          this.activeIndex = i
          // this.activeName = this.MenuList[i].title;
          break
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
#staff {
  position: relative;
  padding: 50px 0 0 150px;
  height: 100%;
  .top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #eee;
    line-height: 50px;
    padding: 0 20px;
  }
  .left {
    position: absolute;
    top: 50px;
    left: 0;
    width: 150px;
    height: calc(100% - 50px);
    background: #ecf5ff;
  }
  .el-menu {
    border: 0;
    border: 0;
    /deep/ .el-menu-item.is-active {
      background-color: #409eff !important;
    }
  }
  .right {
    background: #eee;
    padding: 8px;
    height: 100%;
    .main {
      height: 100%;
      background: #fff;
      border-radius: 5px;
      padding: 8px;
      overflow: hidden;
      /deep/ .el-scrollbar__wrap {
        overflow-x: hidden;
      }
    }
  }
}
</style>
